var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgProgrammable = function SvgProgrammable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12532 23.6511C10.6201 22.353 14.3797 23.7904 16.5456 23.1647C18.7115 22.539 22.9012 19.9801 20.0237 10.0151C17.1462 0.0500706 10.6053 0.355813 8.22223 1.04373C-2.93398 4.26552 -1.83547 25.9502 6.12532 23.6511Z",
    fill: "#E2EEF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04492 8.3335L4.00153 7.37689L4.47983 7.85519L3.52322 8.8118L3.04492 8.3335Z",
    fill: "#A4AFC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.292969 11.0825L1.24957 10.1259L1.72787 10.6042L0.77127 11.5608L0.292969 11.0825Z",
    fill: "#A4AFC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.292969 7.73682L0.771271 7.25852L1.72787 8.21512L1.24957 8.69341L0.292969 7.73682Z",
    fill: "#A4AFC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9951 6.5151C16.4357 6.5151 15.9805 6.05987 15.9805 5.50047C15.9805 4.94107 16.4357 4.48584 16.9951 4.48584C17.5545 4.48584 18.0097 4.94107 18.0097 5.50047C18.0097 6.05987 17.5545 6.5151 16.9951 6.5151ZM16.9951 5.16226C16.8091 5.16226 16.6569 5.31446 16.6569 5.50047C16.6569 5.68649 16.8091 5.83868 16.9951 5.83868C17.1811 5.83868 17.3333 5.68649 17.3333 5.50047C17.3333 5.31446 17.1811 5.16226 16.9951 5.16226Z",
    fill: "#A4AFC1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72461 9.90769V13.4311L14.7323 16.6342V6.70459L6.72461 9.90769Z",
    fill: "#F3F3F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90721 13.8067H6.27468V10.0864H3.90721C3.34713 10.0864 2.89258 10.541 2.89258 11.1011V12.9612C2.89258 13.5213 3.34713 13.8067 3.90721 13.8067Z",
    fill: "#F3F3F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67624 14.1516V9.98557L14.6096 6.87996V6.19824L6.1543 9.98557V14.1516L14.6096 17.939V17.2573L7.67624 14.1516Z",
    fill: "#F3F3F1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41452 12.9612V11.1011C4.41452 10.541 4.86908 10.0864 5.42916 10.0864H3.90721C3.34713 10.0864 2.89258 10.541 2.89258 11.1011V12.9612C2.89258 13.5213 3.34713 13.8067 3.90721 13.8067H5.42916C4.86908 13.8067 4.41452 13.5213 4.41452 12.9612Z",
    fill: "#FDA949"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2832 14.0254L5.95962 18.7603H7.48157L6.83829 14.2588L5.2832 14.0254Z",
    fill: "#FDA949"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7341 17.6971C14.6705 17.6971 14.6069 17.6849 14.546 17.6606L6.09076 14.2785C5.89798 14.2014 5.77148 14.0153 5.77148 13.8077V10.0874C5.77148 9.87971 5.89798 9.69369 6.09076 9.61658L14.546 6.23448C14.7016 6.17089 14.8795 6.19119 15.0188 6.28521C15.1582 6.37923 15.2414 6.53684 15.2414 6.70527V17.1898C15.2414 17.3582 15.1582 17.5151 15.0188 17.6098C14.9336 17.6673 14.8335 17.6971 14.7341 17.6971ZM6.78612 13.4641L14.2267 16.4403V7.45406L6.78612 10.4303V13.4641Z",
    fill: "#62686E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27614 14.3145H3.90866C3.01241 14.3145 2.38672 13.7585 2.38672 12.9617V11.1015C2.38672 10.2628 3.0699 9.57959 3.90866 9.57959H6.27614C6.55617 9.57959 6.78345 9.80687 6.78345 10.0869V13.8072C6.78345 14.0873 6.55617 14.3145 6.27614 14.3145ZM3.90866 10.5942C3.6293 10.5942 3.40135 10.8222 3.40135 11.1015V12.9617C3.40135 13.2411 3.67733 13.2999 3.90866 13.2999H5.76882V10.5942H3.90866Z",
    fill: "#62686E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6236 19.0505H5.59434C5.34203 19.0505 5.12829 18.8651 5.09244 18.6149L4.41602 13.8799L5.41982 13.7358L6.03401 18.0358H7.05608L6.6252 14.1965L7.63307 14.0828L8.12685 18.4863C8.14309 18.6304 8.09709 18.7738 8.00104 18.8814C7.90566 18.9889 7.76835 19.0505 7.6236 19.0505Z",
    fill: "#62686E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1074 9.68896L17.7985 8.33567L18.4329 9.1284L16.7418 10.4817L16.1074 9.68896Z",
    fill: "#62686E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1152 14.8804L16.7496 14.0877L18.4407 15.4409L17.8063 16.2337L16.1152 14.8804Z",
    fill: "#62686E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4258 11.7793H18.1168V12.7939H16.4258V11.7793Z",
    fill: "#62686E"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProgrammable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/programmable.a645774e.svg";
export { ForwardRef as ReactComponent };